// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doclist {
   list-style: none;
   margin: 0;
   padding: 0;
}
.doclist li {
   align-items: center;
   border-top: 1px solid transparent;
   border-bottom: 1px solid #eaeaea;
   margin-top: -1px;
}
.doclist li.selected {
   background-color: rgba(0,178,201,0.05);
   border-color: rgba(26,89,118,0.1);
}
.file-icon img {
   display: block;
   margin: 8px;
   width: 32px;
   height: 32px;
   object-fit: contain;
}
.file-icon img.cover {
   object-fit: cover;
}
.file-filename {
   padding: 6px 0;
}
.file-filename a {
   cursor: pointer;
}
.file-name {
   align-items: center;
   display: inline-flex;
   max-width: 100%;
}
.file-name a, .file-name .name {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 95%;
}
.file-name .link {
   fill: #FFA726;
   cursor: pointer;
   display: inline-block;
   margin-left: 8px;
   width: 16px;
   height: 16px;
   outline: none;
}
.file-upload {
    display: none;
    overflow: hidden;
    width: 0;
    height: 0;
}
.file-name input {
   border: 1px solid rgba(42, 180, 192, .5);
   border-radius: 2px;
   display: none;
   width: 100%;
   outline: none;
   margin-left: -5px;
   padding: 4px;
}
.file-version {
   border: 1px solid rgba(0, 0, 0, .2);
   border-radius: 2px;
   color: rgba(0, 0, 0, .5);
   font-size: 11px;
   height: 18px;
   margin-left: 5px;
   opacity: .7;
   padding: 1px 4px;
}
.selected .file-version {
   border-color: rgba(0, 0, 0, .4);
   color: #555;
}
.editing a, .editing .link {
    display: none;
}
.editing input {
    display: block;
}

.action-button {
   background-color: #fff;
   border: 1px solid #ccc;
   border-radius: 3px;
   cursor: pointer;
   display: none;
   font-size: 13px;
   line-height: 21px;
   outline: none;
   position: relative;
   margin-left: 10px;
   min-width: 50px;
   padding: 0 10px;
   text-align: center;
}
.file-delete { margin-right: 10px; }
.doclist li:hover .action-button {
   display: block;
}
.file-action {
   color: #aaa;
   height: 40px;
}
.doclist li:hover .file-action {
   color: inherit;
}
.mat-menu-item {
   min-width: 11em;
}
.file-desc, .file-path {
   color: #999;
   font-size: 13px;
}
.file-path {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.margin-top {
   margin-top: 4px;
}

.info {
   padding-left: 25px;
   position: relative;
   transition: min-width .5s, width .5s;
   min-width: 265px;
   width: 265px;
}
.collapse {
   padding-left: 0;
   min-width: 0;
   width: 0;
}
.info-title {
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   padding-top: 10px;
   /*position: fixed;*/
   position: relative;
   width: 250px;
   z-index: 4;
}
.title-label {
   color: #777;
   cursor: pointer;
   line-height: 32px;
   padding: 0 .5em;
   position: relative;
}
.title-label:hover,
.title-label.selected {
   color: #444;
}
.info-title .indicator {
   background-color: #ba68c8;
   position: absolute;
   left: 0;
   bottom: 0;
   height: 2px;
   transition: .5s cubic-bezier(.35,0,.25,1);
}

.info-body {
   /*position: fixed;*/
   /*top: 139px; !* initialize position *!*/
   margin: 5px 0;
   /*margin-top: 65px;*/
   width: 240px;
   /*position: relative;*/
   /*top: 40px;*/
}
.section-header {
   border-bottom: 1px solid #e5e5e5;
   color: #444;
   padding-bottom: .5em;
   margin-top: 20px;
}
.info .properties {
   font-size: 13px;
   line-height: 16px;
   margin: 0;
   padding: 0;
}
.info .preview {
   /*background-color: white;
   background-image: -webkit-linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef), -webkit-linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef);
   background-image: linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef), linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef);
   background-position: 0 0, 10px 10px;
   -webkit-background-size: 21px 21px;
   background-size: 21px 21px;*/
   display: flex;
   align-items: center;
   justify-content: center;
   margin: 1em 0;
   position: relative;
   width: 100%;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .info .preview {
      display: inline;
   }
}
.info .preview .loader-overlay {
    position: static;
    height: 240px;
}
.info .preview img {
   box-shadow: 0 0 1px rgba(0,0,0,.1), 1px 2px 6px rgba(0,0,0,.1);
   display: block;
   height: auto;
   margin: 0 auto;
   max-width: 100%;
   max-height: 100%;
   width: auto;
}
.info label,
.info dl dt {
   color: #999;
   display: block;
   font-weight: 400;
   margin: 20px 0 0;
   padding-bottom: 3px;
}
.info dl dd {
   margin: 0 0 20px;
   word-break: break-all;
}
.info input,
.info textarea {
   background: transparent;
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   color: #444;
   font-size: 13px;
   outline: none;
   padding: 4px;
   resize: none;
   width: 100%;
}
.info select { color: #444 }
.info .description {
   border-color: transparent;
}
.info .description:not([readonly]):hover,
.info .description:not([readonly]):focus {
   border-color: #e5e5e5;
}
.properties label {
   margin-top: 15px;
}
.select-type {
   margin-top: 20px;
   width: 100%;
}
.save-metadata {
   margin-top: 20px;
   text-align: right;
}

.save-button {
   line-height: 1.6;
   min-width: inherit;
   padding: 0 1em;
}

.no-info {
   color: #aaa;
   padding: 60px 50px 0;
   text-align: center;
}
.no-info img {
   display: block;
   margin: 0 auto 8px;
   opacity: .7;
   width: 90px;
   height: auto;
}

.info-body .load-more {
   position: absolute;
   left: 91px;
   top: 40px;
}
.no-select {
   -webkit-user-select: none;
   user-select: none;
}
.item-path {
   color: #4b5049;
}

::ng-deep .mat-checkbox-inner-container {
   height: 15px !important;
   width: 15px !important;;
}

.info::ng-deep .mat-tab-label {
   height: 36px;
   padding: 0 5px;
   min-width: 0;
}
.info::ng-deep .mat-tab-body-content {
   overflow: hidden;
   width: 240px;
}
.comments-container {
   overflow-y: auto;
   margin-bottom: 20px;
}
.no-comment {
   padding: 1em;
}
.comments-container ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.comments-container li {
   margin-top: 1em;
}
.comment-item {
   line-height: 20px;
   margin-left: 48px;
   position: relative;
}
.comment-item a {
   cursor: pointer;
   white-space: nowrap;
   width: 150px;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
}
.comment-item .avatar {
   float: left;
   margin-left: -48px;
   margin-top: 3px;
   width: 36px;
   height: 36px;
   border-radius: 50%;
   object-fit: cover;
}
.comment-item .time {
   color: #657786;
   font-size: 12px;
}
.comment-item .time:before {
   content: "\\00b7";
   padding: 0 5px;
}
.comment-item .delete {
   color: #999;
   cursor: pointer;
   position: absolute;
   top: 0;
   right: 0;
   font-size: 20px;
   width: 20px;
   height: 20px;
   display: none;
}
.comment-item:hover .delete {
   display: block;
}
.comment-item .delete:hover {
   color: #d32f2f;
}
.add-comment {
   text-align: right;
   margin: 20px 0;
}
.add-comment textarea {
   display: block;
}
.add-comment button {
   margin-top: .5em;
   padding: 1px 16px;
   line-height: initial;
   min-width: 64px;
}
.editing .item-content, .textarea-content {
   display: none;
}
.editing .textarea-content {
   display: block;
}
.textarea-content {
   margin-top: 5px;
}
.edit2, .delete2 {
   color: #999;
   vertical-align: middle;
   font-size: 16px;
   text-align: center;
   display: none;
   cursor: pointer;
}
.delete2:hover {
   color: #d32f2f;
}
.edit2:hover {
   color: #00bed6;
}
.comment-item:hover .delete2, .comment-item:hover .edit2  {
   display: table-cell;
}
.mat-button {
   min-width: 0px;
}
.mat-button.save {
   color: #00bed6;
}
.textarea-content div {
   text-align: right;
}
.btn-comment {
   position: absolute;
   top: 0;
   right: 0;
}
.item-content {
   width: 190px;
   word-wrap: break-word;
   white-space: pre-line;
}
@media (min-width: 480px) {
   .list-container {
      max-width: 100%;
   }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
   .info {
      min-width: 225px;
      width: 225px;
   }
}
@media only screen and (min-width: 480px) and (max-width: 768px) {
   .info {
      padding-left: 0px;
      min-width: 195px;
      width: 195px;
   }
   .list-container {
      min-width: 768px;
      width: 768px;
   }
}
@media only screen and (max-width: 480px) {
   .info {
      padding-left: 0px;
      min-width: 165px;
      width: 165px;
   }
   .list-container {
      min-width: 480px;
      width: 480px;
   }
}
.file-icon-sign img {
   display: block;
   width: 16px;
   height: 16px;
   object-fit: contain;
   margin-left: 5px;
   margin-top: 2px;
}
.author-name {
   margin-right: 4em;
   word-wrap: break-word;
   white-space: pre-line;
}
.start-flow {
   cursor: pointer;
}

.info-title-share {
   border-bottom: 1px solid #eaeaea;
   padding-top: 10px;
   position: relative;
   width: 240px;
   z-index: 4;
}

.icon-flag
{
   display: inline-block;
   margin-left: 8px;
   width: 22px;
   height: 22px;
   outline: none;
}
.image-opacity {
   opacity: 0.4!important;
   filter: alpha(opacity=40)!important;
}
.image-opacity-normal{
   opacity: 0.75;
   filter: alpha(opacity=75);
}

.viewer { width: auto; height: auto;}

::ng-deep .mat-menu-item{
   width:100%!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/doclist/doclist.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,mBAAmB;GACnB,iCAAiC;GACjC,gCAAgC;GAChC,gBAAgB;AACnB;AACA;GACG,sCAAsC;GACtC,iCAAiC;AACpC;AACA;GACG,cAAc;GACd,WAAW;GACX,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,mBAAmB;GACnB,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,cAAc;AACjB;AACA;GACG,aAAa;GACb,eAAe;GACf,qBAAqB;GACrB,gBAAgB;GAChB,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,SAAS;AACb;AACA;GACG,wCAAwC;GACxC,kBAAkB;GAClB,aAAa;GACb,WAAW;GACX,aAAa;GACb,iBAAiB;GACjB,YAAY;AACf;AACA;GACG,mCAAmC;GACnC,kBAAkB;GAClB,wBAAwB;GACxB,eAAe;GACf,YAAY;GACZ,gBAAgB;GAChB,WAAW;GACX,gBAAgB;AACnB;AACA;GACG,+BAA+B;GAC/B,WAAW;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,eAAe;GACf,iBAAiB;GACjB,aAAa;GACb,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,eAAe;GACf,kBAAkB;AACrB;AACA,eAAe,kBAAkB,EAAE;AACnC;GACG,cAAc;AACjB;AACA;GACG,WAAW;GACX,YAAY;AACf;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,oCAAoC;GACpC,gBAAgB;GAChB,YAAY;AACf;AACA;GACG,eAAe;GACf,YAAY;GACZ,QAAQ;AACX;AACA;GACG,sBAAsB;GACtB,gCAAgC;GAChC,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;GAClB,YAAY;GACZ,UAAU;AACb;AACA;GACG,WAAW;GACX,eAAe;GACf,iBAAiB;GACjB,eAAe;GACf,kBAAkB;AACrB;AACA;;GAEG,WAAW;AACd;AACA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,OAAO;GACP,SAAS;GACT,WAAW;GACX,yCAAyC;AAC5C;;AAEA;GACG,mBAAmB;GACnB,wCAAwC;GACxC,aAAa;GACb,oBAAoB;GACpB,YAAY;GACZ,sBAAsB;GACtB,aAAa;AAChB;AACA;GACG,gCAAgC;GAChC,WAAW;GACX,oBAAoB;GACpB,gBAAgB;AACnB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,SAAS;GACT,UAAU;AACb;AACA;GACG;;;;;+BAK4B;GAC5B,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,aAAa;GACb,kBAAkB;GAClB,WAAW;AACd;AACA;GACG;MACG,eAAe;GAClB;AACH;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;GACG,8DAA8D;GAC9D,cAAc;GACd,YAAY;GACZ,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,WAAW;AACd;AACA;;GAEG,WAAW;GACX,cAAc;GACd,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;AACtB;AACA;GACG,gBAAgB;GAChB,qBAAqB;AACxB;AACA;;GAEG,uBAAuB;GACvB,yBAAyB;GACzB,kBAAkB;GAClB,WAAW;GACX,eAAe;GACf,aAAa;GACb,YAAY;GACZ,YAAY;GACZ,WAAW;AACd;AACA,eAAe,YAAY;AAC3B;GACG,yBAAyB;AAC5B;AACA;;GAEG,qBAAqB;AACxB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,WAAW;AACd;AACA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,oBAAoB;GACpB,kBAAkB;AACrB;AACA;GACG,cAAc;GACd,kBAAkB;GAClB,WAAW;GACX,WAAW;GACX,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,UAAU;GACV,SAAS;AACZ;AACA;GACG,yBAAyB;GAGzB,iBAAiB;AACpB;AACA;GACG,cAAc;AACjB;;AAEA;GACG,uBAAuB;GACvB,sBAAsB;AACzB;;AAEA;GACG,YAAY;GACZ,cAAc;GACd,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;AACA;GACG,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;AAClB;AACA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,eAAe;GACf,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;GAChB,uBAAuB;GACvB,cAAc;AACjB;AACA;GACG,WAAW;GACX,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,cAAc;AACjB;AACA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,eAAe;GACf,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,iBAAiB;GACjB,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,aAAa;AAChB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,WAAW;GACX,sBAAsB;GACtB,eAAe;GACf,kBAAkB;GAClB,aAAa;GACb,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,mBAAmB;AACtB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;AACX;AACA;GACG,YAAY;GACZ,qBAAqB;GACrB,qBAAqB;AACxB;AACA;GACG;MACG,eAAe;GAClB;AACH;AACA;GACG;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG;MACG,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;GACf;GACA;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG;MACG,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;GACf;GACA;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,gBAAgB;GAChB,eAAe;AAClB;AACA;GACG,iBAAiB;GACjB,qBAAqB;GACrB,qBAAqB;AACxB;AACA;GACG,eAAe;AAClB;;AAEA;GACG,gCAAgC;GAChC,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,UAAU;AACb;;AAEA;;GAEG,qBAAqB;GACrB,gBAAgB;GAChB,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;GACG,sBAAsB;GACtB,mCAAmC;AACtC;AACA;GACG,aAAa;GACb,yBAAyB;AAC5B;;AAEA,UAAU,WAAW,EAAE,YAAY,CAAC;;AAEpC;GACG,oBAAoB;AACvB","sourcesContent":[".doclist {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.doclist li {\n   align-items: center;\n   border-top: 1px solid transparent;\n   border-bottom: 1px solid #eaeaea;\n   margin-top: -1px;\n}\n.doclist li.selected {\n   background-color: rgba(0,178,201,0.05);\n   border-color: rgba(26,89,118,0.1);\n}\n.file-icon img {\n   display: block;\n   margin: 8px;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n}\n.file-icon img.cover {\n   object-fit: cover;\n}\n.file-filename {\n   padding: 6px 0;\n}\n.file-filename a {\n   cursor: pointer;\n}\n.file-name {\n   align-items: center;\n   display: inline-flex;\n   max-width: 100%;\n}\n.file-name a, .file-name .name {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   max-width: 95%;\n}\n.file-name .link {\n   fill: #FFA726;\n   cursor: pointer;\n   display: inline-block;\n   margin-left: 8px;\n   width: 16px;\n   height: 16px;\n   outline: none;\n}\n.file-upload {\n    display: none;\n    overflow: hidden;\n    width: 0;\n    height: 0;\n}\n.file-name input {\n   border: 1px solid rgba(42, 180, 192, .5);\n   border-radius: 2px;\n   display: none;\n   width: 100%;\n   outline: none;\n   margin-left: -5px;\n   padding: 4px;\n}\n.file-version {\n   border: 1px solid rgba(0, 0, 0, .2);\n   border-radius: 2px;\n   color: rgba(0, 0, 0, .5);\n   font-size: 11px;\n   height: 18px;\n   margin-left: 5px;\n   opacity: .7;\n   padding: 1px 4px;\n}\n.selected .file-version {\n   border-color: rgba(0, 0, 0, .4);\n   color: #555;\n}\n.editing a, .editing .link {\n    display: none;\n}\n.editing input {\n    display: block;\n}\n\n.action-button {\n   background-color: #fff;\n   border: 1px solid #ccc;\n   border-radius: 3px;\n   cursor: pointer;\n   display: none;\n   font-size: 13px;\n   line-height: 21px;\n   outline: none;\n   position: relative;\n   margin-left: 10px;\n   min-width: 50px;\n   padding: 0 10px;\n   text-align: center;\n}\n.file-delete { margin-right: 10px; }\n.doclist li:hover .action-button {\n   display: block;\n}\n.file-action {\n   color: #aaa;\n   height: 40px;\n}\n.doclist li:hover .file-action {\n   color: inherit;\n}\n.mat-menu-item {\n   min-width: 11em;\n}\n.file-desc, .file-path {\n   color: #999;\n   font-size: 13px;\n}\n.file-path {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.margin-top {\n   margin-top: 4px;\n}\n\n.info {\n   padding-left: 25px;\n   position: relative;\n   transition: min-width .5s, width .5s;\n   min-width: 265px;\n   width: 265px;\n}\n.collapse {\n   padding-left: 0;\n   min-width: 0;\n   width: 0;\n}\n.info-title {\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   padding-top: 10px;\n   /*position: fixed;*/\n   position: relative;\n   width: 250px;\n   z-index: 4;\n}\n.title-label {\n   color: #777;\n   cursor: pointer;\n   line-height: 32px;\n   padding: 0 .5em;\n   position: relative;\n}\n.title-label:hover,\n.title-label.selected {\n   color: #444;\n}\n.info-title .indicator {\n   background-color: #ba68c8;\n   position: absolute;\n   left: 0;\n   bottom: 0;\n   height: 2px;\n   transition: .5s cubic-bezier(.35,0,.25,1);\n}\n\n.info-body {\n   /*position: fixed;*/\n   /*top: 139px; !* initialize position *!*/\n   margin: 5px 0;\n   /*margin-top: 65px;*/\n   width: 240px;\n   /*position: relative;*/\n   /*top: 40px;*/\n}\n.section-header {\n   border-bottom: 1px solid #e5e5e5;\n   color: #444;\n   padding-bottom: .5em;\n   margin-top: 20px;\n}\n.info .properties {\n   font-size: 13px;\n   line-height: 16px;\n   margin: 0;\n   padding: 0;\n}\n.info .preview {\n   /*background-color: white;\n   background-image: -webkit-linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef), -webkit-linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef);\n   background-image: linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef), linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%, #efefef);\n   background-position: 0 0, 10px 10px;\n   -webkit-background-size: 21px 21px;\n   background-size: 21px 21px;*/\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   margin: 1em 0;\n   position: relative;\n   width: 100%;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n   .info .preview {\n      display: inline;\n   }\n}\n.info .preview .loader-overlay {\n    position: static;\n    height: 240px;\n}\n.info .preview img {\n   box-shadow: 0 0 1px rgba(0,0,0,.1), 1px 2px 6px rgba(0,0,0,.1);\n   display: block;\n   height: auto;\n   margin: 0 auto;\n   max-width: 100%;\n   max-height: 100%;\n   width: auto;\n}\n.info label,\n.info dl dt {\n   color: #999;\n   display: block;\n   font-weight: 400;\n   margin: 20px 0 0;\n   padding-bottom: 3px;\n}\n.info dl dd {\n   margin: 0 0 20px;\n   word-break: break-all;\n}\n.info input,\n.info textarea {\n   background: transparent;\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   color: #444;\n   font-size: 13px;\n   outline: none;\n   padding: 4px;\n   resize: none;\n   width: 100%;\n}\n.info select { color: #444 }\n.info .description {\n   border-color: transparent;\n}\n.info .description:not([readonly]):hover,\n.info .description:not([readonly]):focus {\n   border-color: #e5e5e5;\n}\n.properties label {\n   margin-top: 15px;\n}\n.select-type {\n   margin-top: 20px;\n   width: 100%;\n}\n.save-metadata {\n   margin-top: 20px;\n   text-align: right;\n}\n\n.save-button {\n   line-height: 1.6;\n   min-width: inherit;\n   padding: 0 1em;\n}\n\n.no-info {\n   color: #aaa;\n   padding: 60px 50px 0;\n   text-align: center;\n}\n.no-info img {\n   display: block;\n   margin: 0 auto 8px;\n   opacity: .7;\n   width: 90px;\n   height: auto;\n}\n\n.info-body .load-more {\n   position: absolute;\n   left: 91px;\n   top: 40px;\n}\n.no-select {\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n}\n.item-path {\n   color: #4b5049;\n}\n\n::ng-deep .mat-checkbox-inner-container {\n   height: 15px !important;\n   width: 15px !important;;\n}\n\n.info::ng-deep .mat-tab-label {\n   height: 36px;\n   padding: 0 5px;\n   min-width: 0;\n}\n.info::ng-deep .mat-tab-body-content {\n   overflow: hidden;\n   width: 240px;\n}\n.comments-container {\n   overflow-y: auto;\n   margin-bottom: 20px;\n}\n.no-comment {\n   padding: 1em;\n}\n.comments-container ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.comments-container li {\n   margin-top: 1em;\n}\n.comment-item {\n   line-height: 20px;\n   margin-left: 48px;\n   position: relative;\n}\n.comment-item a {\n   cursor: pointer;\n   white-space: nowrap;\n   width: 150px;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   display: block;\n}\n.comment-item .avatar {\n   float: left;\n   margin-left: -48px;\n   margin-top: 3px;\n   width: 36px;\n   height: 36px;\n   border-radius: 50%;\n   object-fit: cover;\n}\n.comment-item .time {\n   color: #657786;\n   font-size: 12px;\n}\n.comment-item .time:before {\n   content: \"\\00b7\";\n   padding: 0 5px;\n}\n.comment-item .delete {\n   color: #999;\n   cursor: pointer;\n   position: absolute;\n   top: 0;\n   right: 0;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   display: none;\n}\n.comment-item:hover .delete {\n   display: block;\n}\n.comment-item .delete:hover {\n   color: #d32f2f;\n}\n.add-comment {\n   text-align: right;\n   margin: 20px 0;\n}\n.add-comment textarea {\n   display: block;\n}\n.add-comment button {\n   margin-top: .5em;\n   padding: 1px 16px;\n   line-height: initial;\n   min-width: 64px;\n}\n.editing .item-content, .textarea-content {\n   display: none;\n}\n.editing .textarea-content {\n   display: block;\n}\n.textarea-content {\n   margin-top: 5px;\n}\n.edit2, .delete2 {\n   color: #999;\n   vertical-align: middle;\n   font-size: 16px;\n   text-align: center;\n   display: none;\n   cursor: pointer;\n}\n.delete2:hover {\n   color: #d32f2f;\n}\n.edit2:hover {\n   color: #00bed6;\n}\n.comment-item:hover .delete2, .comment-item:hover .edit2  {\n   display: table-cell;\n}\n.mat-button {\n   min-width: 0px;\n}\n.mat-button.save {\n   color: #00bed6;\n}\n.textarea-content div {\n   text-align: right;\n}\n.btn-comment {\n   position: absolute;\n   top: 0;\n   right: 0;\n}\n.item-content {\n   width: 190px;\n   word-wrap: break-word;\n   white-space: pre-line;\n}\n@media (min-width: 480px) {\n   .list-container {\n      max-width: 100%;\n   }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n   .info {\n      min-width: 225px;\n      width: 225px;\n   }\n}\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n   .info {\n      padding-left: 0px;\n      min-width: 195px;\n      width: 195px;\n   }\n   .list-container {\n      min-width: 768px;\n      width: 768px;\n   }\n}\n@media only screen and (max-width: 480px) {\n   .info {\n      padding-left: 0px;\n      min-width: 165px;\n      width: 165px;\n   }\n   .list-container {\n      min-width: 480px;\n      width: 480px;\n   }\n}\n.file-icon-sign img {\n   display: block;\n   width: 16px;\n   height: 16px;\n   object-fit: contain;\n   margin-left: 5px;\n   margin-top: 2px;\n}\n.author-name {\n   margin-right: 4em;\n   word-wrap: break-word;\n   white-space: pre-line;\n}\n.start-flow {\n   cursor: pointer;\n}\n\n.info-title-share {\n   border-bottom: 1px solid #eaeaea;\n   padding-top: 10px;\n   position: relative;\n   width: 240px;\n   z-index: 4;\n}\n\n.icon-flag\n{\n   display: inline-block;\n   margin-left: 8px;\n   width: 22px;\n   height: 22px;\n   outline: none;\n}\n.image-opacity {\n   opacity: 0.4!important;\n   filter: alpha(opacity=40)!important;\n}\n.image-opacity-normal{\n   opacity: 0.75;\n   filter: alpha(opacity=75);\n}\n\n.viewer { width: auto; height: auto;}\n\n::ng-deep .mat-menu-item{\n   width:100%!important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
